module.exports = __webpack_public_path__ + "img/license.39120bf3.png";